import { z } from "zod/v4";

export const DeleteSchedulePathParamSchema = z.object({
  scheduleId: z.uuid(),
});

export type DeleteSchedulePathParamType = z.infer<
  typeof DeleteSchedulePathParamSchema
>;

export const DeleteScheduleResponseBodySchema = z.string();

export type DeleteScheduleResponseBodyType = z.infer<
  typeof DeleteScheduleResponseBodySchema
>;
